import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Translation } from './translation'
import { translationActions } from './translation.actions'
import * as fromTranslation from './translation.reducer'
import { TranslationService } from './translation.service'

@Injectable()
export class TranslationEffects extends ResourceEffects<Translation> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public translationService: TranslationService
  ) {
    super(
      fromTranslation.FEATURE_NAME,
      translationService,
      translationActions,
      actions$
    )
  }
}
